module.exports = __webpack_public_path__ + "static/media/academia-img2.af6e533d.svg";